import { defineMessages, FormattedMessage } from 'react-intl';

export const orderMessages = defineMessages({
  homeDelivery: {
    defaultMessage: 'Home delivery',
    id: `checkout.delivery.home`,
  },
  boutiquePickUp: {
    defaultMessage: 'Boutique pick up',
    id: `checkout.delivery.boutique`,
  },
  giftingMessageTitle: {
    defaultMessage: 'Gifting message',
    id: `checkout.giftingMessage.title`,
  },
  giftingMessageFrom: {
    defaultMessage: 'From',
    id: `checkout.giftingMessage.from`,
  },
  checkYourOrder: {
    defaultMessage: 'Check your order',
    id: 'orderStatusView.checkYourOrder',
  },
  enterDetailsToCheckStatus: {
    defaultMessage:
      'Enter the requested details to see the status of your order. This may take a few minutes if your order was just placed.',
    id: 'orderStatusForm.enterDetailsToCheckStatus',
  },
  checkStatus: {
    defaultMessage: 'Check Status',
    id: 'orderStatusForm.checkStatus',
  },
  errorNetwork: {
    defaultMessage: 'An unexpected error occurred. Please try again later.',
    id: 'orderStatusForm.networkError',
  },
  orderEmail: {
    defaultMessage: 'Order e-mail',
    id: 'orderStatusForm.orderEmail',
  },
  orderNumber: {
    defaultMessage: 'Order number',
    id: 'orderStatusForm.orderNumber',
  },
  noMatch: {
    defaultMessage:
      'Please check the order number and email address you entered and make sure you are on the site of the country where you made the purchase.',
    id: 'orderStatusView.noMatch',
  },
  fetchError: {
    defaultMessage: 'Error fetching order data. Please try again later.',
    id: 'orderStatusView.fetchError',
  },
});

export const DeliveryInformation = (
  <FormattedMessage
    defaultMessage='Delivery information'
    id='checkout.reviewOrder.deliveryInformation'
  />
);

export const Gifting = (
  <FormattedMessage defaultMessage='Gifting' id='order.gifting' />
);

export const OrderCreationDate = (
  <FormattedMessage
    defaultMessage='Order creation date'
    id='order.creationDate'
  />
);

export const OrderNumber = (
  <FormattedMessage defaultMessage='Order number' id='order.number.title' />
);

export const OrderStatus = (
  <FormattedMessage defaultMessage='Order status' id='order.status' />
);

export const TrackingNumber = (
  <FormattedMessage
    defaultMessage='Tracking number'
    id='order.trackingNumber'
  />
);

export const ReadyToShipOrderStatus = (
  <FormattedMessage
    defaultMessage='Ready to ship'
    id='order.readyToShipOrderStatus'
  />
);

export const PickedUpOrderStatus = (
  <FormattedMessage defaultMessage='Picked up' id='order.pickedUpOrderStatus' />
);

export const CanceledOrderStatus = (
  <FormattedMessage defaultMessage='Cancelled' id='order.canceledOrderStatus' />
);

export const RejectedOrderStatus = (
  <FormattedMessage defaultMessage='Rejected' id='order.rejectedOrderStatus' />
);

export const ConfirmedOrderStatus = (
  <FormattedMessage
    defaultMessage='Confirmed'
    id='order.confirmedOrderStatus'
  />
);

export const DraftOrderStatus = (
  <FormattedMessage defaultMessage='Draft' id='order.draftOrderStatus' />
);

export const InPreparationOrderStatus = (
  <FormattedMessage
    defaultMessage='In preparation'
    id='order.inPreparationOrderStatus'
  />
);

export const PreorderCancelled = (
  <FormattedMessage
    defaultMessage='Preorder cancelled'
    id='order.preorderCancelled'
  />
);

export const InValidationOrderStatus = (
  <FormattedMessage
    defaultMessage='In validation'
    id='order.inValidationOrderStatus'
  />
);

export const PartialPaymentInValidationOrderStatus = (
  <FormattedMessage
    defaultMessage='Partial payment in validation'
    id='order.partialPaymentInValidationOrderStatus'
  />
);

export const PartialPaymentRejectedOrderStatus = (
  <FormattedMessage
    defaultMessage='Partial payment rejected'
    id='order.partialPaymentRejectedOrderStatus'
  />
);

export const PartialPaymentReceivedOrderStatus = (
  <FormattedMessage
    defaultMessage='Partial payment recieved'
    id='order.partialPaymentReceivedOrderStatus'
  />
);

export const PartiallyPaidOrderStatus = (
  <FormattedMessage
    defaultMessage='Partially paid'
    id='order.partiallyPaidOrderStatus'
  />
);

export const PendingPaymentOrderStatus = (
  <FormattedMessage
    defaultMessage='Pending payment'
    id='order.pendingPaymentOrderStatus'
  />
);

export const ReadyForCollectionOrderStatusDescription = (
  <FormattedMessage
    defaultMessage='The boutique will contact you when order is ready.'
    id='order.readyForCollectionOrderStatus'
  />
);

export const ShippedOrderStatus = (
  <FormattedMessage defaultMessage='Shipped' id='order.shippedOrderStatus' />
);

export const CollectedOrderStatus = (
  <FormattedMessage defaultMessage='Picked up' id='order.collected' />
);

export const ReturnedOrderStatus = (
  <FormattedMessage defaultMessage='Returned' id='order.returned' />
);

export const PartiallyReturnedOrderStatus = (
  <FormattedMessage
    defaultMessage='Partially returned'
    id='order.partiallyReturned'
  />
);

export const TrackMyOrder = (
  <FormattedMessage defaultMessage='Track my order' id='order.trackMyOrder' />
);

export const InReturnOrderStatus = (
  <FormattedMessage defaultMessage='In return' id='order.inReturnOrderStatus' />
);

export const ReturnRegisteredOrderStatus = (
  <FormattedMessage
    defaultMessage='Return registered'
    id='order.returnRegisteredOrderStatus'
  />
);

export const ReturnReceivedOrderStatus = (
  <FormattedMessage
    defaultMessage='Return received'
    id='order.returnReceivedOrderStatus'
  />
);

export const ReturnAcceptedOrderStatus = (
  <FormattedMessage
    defaultMessage='Return accepted'
    id='order.returnAcceptedOrderStatus'
  />
);

export const ReturnRejectedOrderStatus = (
  <FormattedMessage
    defaultMessage='Return rejected'
    id='order.returnRejectedOrderStatus'
  />
);

export const ReturnCancelledOrderStatus = (
  <FormattedMessage
    defaultMessage='Return cancelled'
    id='order.returnCancelledOrderStatus'
  />
);

export const ReturnPartiallyReturnedOrderStatus = (
  <FormattedMessage
    defaultMessage='Partially returned'
    id='order.returnPartiallyReturnedOrderStatus'
  />
);

export const ReturnRefundedOrderStatus = (
  <FormattedMessage
    defaultMessage='Refunded'
    id='order.returnRefundedOrderStatus'
  />
);

export const CompletedOrderStatus = (
  <FormattedMessage
    defaultMessage='Completed'
    id='order.completedOrderStatus'
  />
);

export const ReturnOrderCreationDate = (
  <FormattedMessage defaultMessage='Return date' id='order.returnDate' />
);

export const ReturnOrderNumber = (
  <FormattedMessage defaultMessage='Return Number' id='order.returnNumber' />
);

export const OrderReminder = (
  <FormattedMessage
    defaultMessage='Thank you for your order! Please complete the payment to proceed with your purchase.'
    id='order.reminder'
  />
);
